import * as React from 'react';
const ForforaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M54.75 115.08h11.73c8.38 0 12.19-1.67 15.44-1.67.35 0 .75.11 1.14.29 3.69 1.67 1.86 3.96 1.86 8.09 0 15.95 10.59 16.76 12.71 16.76 5.35 0 10.75-3.63 10.75-11.73 0-4.05-1.54-6.34-2.46-7.71-.28-.41-.51-.75-.66-1.37-.42-1.66.42-3.36 1.99-4.04.4-.17.79-.29 1.14-.29 3.25 0 6.7 1.68 15.08 1.68h21.79"
      className="prefix__cls-2"
    />
    <path
      d="M115.08 61.46s-23.46 36.03-23.46 60.33c0 7.65 2.86 10.05 6.01 10.05 2.62 0 4.05-1.68 4.05-5.03 0-4.68-3.35-3.42-3.35-11.73 0-23.57 16.76-53.62 16.76-53.62"
      className="prefix__cls-2"
    />
    <path
      d="M57.61 106.85c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M69.23 106.69c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M63.71 101.91c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M83.7 96.58c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M81.82 106.39c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M75.72 101.76c-.04.07-.01.17.06.2.07.04.17.01.2-.06.04-.07.01-.17-.06-.2-.07-.04-.17-.01-.2.06M135.79 106.85c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06M124.17 106.69c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06M131.01 100.61c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06M112.8 96.43c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06M111.58 106.39c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06M119.91 100.77c.04.07.01.17-.06.2-.07.04-.17.01-.2-.06-.04-.07-.01-.17.06-.2.07-.04.17-.01.2.06"
      className="prefix__cls-1"
    />
  </svg>
);
export default ForforaIcon;
